<template>
  <div>
    <el-card>
      <div slot="header">
        <span style="font-weight:600;color:#000">基本信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="标签名称" prop="tagName">
            <el-input v-model="ruleForm.tagName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签类型" prop="tagType">
            <div>{{ tagType }}</div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card>
      <div slot="header">
        <span style="font-weight:600;color:#000">标签条件</span>
      </div>
      <div style="width: 620px;">
        <el-form ref="tagCondition" :model="tagForm" :rules="tagRules" label-width="100px">
          <el-form-item label="充电量" prop="chargingCapacity">
            <div style="display: flex;">
              <el-input v-model="tagForm.chargingCapacity" placeholder="请输入充电量" />
              <div style="width: 10px;margin-left: 10px;">度</div>
            </div>
          </el-form-item>
          <el-form-item label="或" />
          <el-form-item label="消费金额" prop="consumptionAmount">
            <div style="display: flex;">
              <el-input v-model="tagForm.consumptionAmount" placeholder="请输入消费金额" />
              <div style="width: 10px;margin-left: 10px;">元</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      tagType: '',
      ruleForm: {
        tagName: '', // 标签名称
        type: '1' // 标签名称
      },
      rules: {
        tagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ]
      },
      tagForm: {
        chargingCapacity: '', // 充电量
        consumptionAmount: ''// 消费金额
      },
      tagRules: {
        chargingCapacity: [
          { required: true, message: '请输入充电量', trigger: 'blur' }
        ],
        consumptionAmount: [
          { required: true, message: '请输入消费金额', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSubmit() {
      let ruleFormBool = false
      let tagConditionBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })
      this.$refs['tagCondition'].validate(valid => {
        tagConditionBool = valid
      })
      this.$store.dispatch("form/handle", {
        url: "/user/label",
        data: {
          "id": this.id, 
          "name": this.ruleForm.tagName,
          "type": this.ruleForm.type,
          // "bindUsers": this.tags.map((item,i)=>item.id).join(","),
          "chargeCapacity": this.tagForm.chargingCapacity,
          "consumptionAmount": this.tagForm.consumptionAmount
        },
        method: "post",
        callback: resp => {
          this.$router.go(-1)
        }
      });
    },
    cancel() {
      this.$router.go(-1)
    }
  },
  mounted(){
    this.$nextTick(()=>{
      let data = this.$route.query.data
      console.log(data)
      this.id = data.id
      this.ruleForm.tagName = data.name
      this.tagType = data.type
      this.tagForm.chargingCapacity = data.chargeCapacity
      this.tagForm.consumptionAmount = data.consumptionAmount
    })
  }
}
</script>

<style scoped lang="less">
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/discount/modifySystemTag.vue